// extracted by mini-css-extract-plugin
export default {"node":"CustomNode_node__tQ8U8"};